import React from 'react'
import { useEffect, useRef } from 'react'
import { gantChart } from "./anychartMachineGantt";
import { tokens } from "../../../assets/theme";
import { useTheme } from '@mui/material';
import { useLocalStorage } from "../../../hooks/useLocalStorage";

function MachineGantt(props) {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [companyKey, setCompanyKey] = useLocalStorage("companyKey", 1);
    const [ganttDarkMode, setGanttDarkMode] = useLocalStorage("ganttDarkMode", "true");
    const chartContainerRef = useRef(null);
    
    const divClass = props.divClass ? props.divClass : "chart-minigantt";

    useEffect(() => {
            chartContainerRef.current.style.touchAction = 'pan-x pan-y';
        }, []);

    useEffect(() => {
        //Making a chart instance
        const chart = gantChart(props.chartContainer, props.data, props.handleClick, colors, props.startDate, props.endDate, companyKey, ganttDarkMode, {}, [], props.featureFlags, props.showHeader);

        return () => {
            //Preventing duplicate renders
            chart.dispose();
        }
    }, [props.startDate, props.endDate, props.data]);


    return (
      <div id={props.chartContainer} border="0px" ref={chartContainerRef} class={divClass}></div>
    )
}

export default MachineGantt